import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";
import useQuestion from "../hooks/useQuestion";

import AnswerBadge from "./AnswerBadge";

const QuestionRow = ({ questionID }) => {
  const { getAnswer } = useContext(AnswersContext);
  const { question } = useQuestion({ questionID });

  const answer = getAnswer(questionID);

  const rightAnswer = question.answer;

  const hasCorrectAnswer = answer ? answer === rightAnswer : undefined;

  const answerText = answer
    ? Object.values(question.answers).find((i) => i.number === answer).answer
    : "";

  const rightAnswerText = Object.values(question.answers).find(
    (i) => i.number === rightAnswer
  ).answer;

  return (
    <div className="list-group-item">
      <div>
        <AnswerBadge questionID={questionID} />
        {question.category} &mdash; {question.topic}.
        <br />
        {question.number}. {question.question}:
        <br />
        {answer && hasCorrectAnswer && (
          <>
            <span className="text-success" aira-label="Correct answer.">
              {answer}. {answerText}
            </span>
          </>
        )}
        {answer && !hasCorrectAnswer && (
          <>
            <s>
              <span className="text-danger" aira-label="Incorrect answer.">
                {answer}. {answerText}
              </span>
            </s>
            <br />
            <ins>
              <span className="text-success" aira-label="Correct answer.">
                {rightAnswer}. {rightAnswerText}
              </span>
            </ins>
          </>
        )}
        {!answer && (
          <>
            <ins>
              <span className="text-danger" aira-label="Correct answer.">
                {rightAnswer}. {rightAnswerText}
              </span>
            </ins>
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionRow;
